module.exports = __webpack_public_path__ + "static/media/icon-settings.872a665f.svg";